import { z } from 'zod'

export const membershipAccessTierSchema = z.enum(['free', 'premium'])
export type MembershipAccessTier = z.infer<typeof membershipAccessTierSchema>

export const paidMembershipTierSchema = z.enum(['premium'])
export type PaidMembershipTier = z.infer<typeof paidMembershipTierSchema>

export const membershipBillingCycleSchema = z.enum(['monthly', 'yearly'])
export type MembershipBillingCycle = z.infer<
  typeof membershipBillingCycleSchema
>

export const adminComplimentaryMembershipPayloadSchema = z.object({
  user_id: z.string(),
  tier: paidMembershipTierSchema,
  duration_months: z.number().int().positive().default(1),
  reason: z.string().min(1),
})
export type AdminComplimentaryMembershipPayload = z.infer<
  typeof adminComplimentaryMembershipPayloadSchema
>

export const adminUpgradeMembershipPayloadSchema = z.object({
  to_tier: paidMembershipTierSchema,
  billing_cycle: membershipBillingCycleSchema.default('monthly'),
  razorpay_payment_id: z.string().optional(),
})
export type AdminUpgradeMembershipPayload = z.infer<
  typeof adminUpgradeMembershipPayloadSchema
>

export const adminDowngradeMembershipPayloadSchema = z.object({
  to_tier: membershipAccessTierSchema,
})
export type AdminDowngradeMembershipPayload = z.infer<
  typeof adminDowngradeMembershipPayloadSchema
>
